import {action, makeAutoObservable} from "mobx"
import {RootStore} from "../index";
import ReturnModel from "../../model/ReturnModel";
import {ISelect} from "../../interface/ISelect";
import {ReturnItem, ReturnOrder, IReturn} from "../../interface/page/Return";
import React from "react";
import ElementModel from "../../model/ElementModel";
import {ISearchCode} from "../../interface/node/IReason";
import {uuidv4} from "../../helper/uid";
import {enumOrderStatus} from "../../enum/enumOrderStatus";


export class PageReturnStore {
    private rootStore: RootStore | undefined;

    note: string = '';

    getActiveTab: number = 1;

    arProductReturn: ReturnItem[] = [];

    arOrderReturn: ReturnOrder[] = [];

    selectType: ISelect[] = [];
    selectReason: ISelect[] = [];

    public error: string = '';

    private readonly return: IReturn;

    @action setReturnOrder = () => {
        let clientId = this.rootStore?.mainStore.getClientId();

        this.return.userId = this.rootStore?.mainStore.user.id;
        this.return.tradePointId = <number>this.rootStore?.pageBasketStore?.selectedOption?.Points?.value
        if (clientId != null) {
            this.return.clientId = clientId;
        }
        this.return.products = [];
        this.return.shipDate = this.arProductReturn[0].date;
        this.return.note = this.note;
        this.return.productTypeInReturn = parseInt(this.arProductReturn[0]?.selectedType.value);
    }

    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
        this.arProductReturn.push(this.newReturnItem(false));
        this.return = this.setReturn();
    }

    setReturn() {
        return {
            tradePointId: 0,
            scaleDiscountByPaymentDateId: 0,
            shipDate: '',
            deliveryTimeFrom: '08:00:00',
            deliveryTimeTo: '16:00:00',
            deliveryTypeId: 0,
            notJoin: false,
            orderSum: 0,
            note: '',
            siteId: this.rootStore?.mainStore?.user?.siteId,
            ex_id: uuidv4(),
            clientId: 0,
            userId: 0,
            isProcessed: false,
            status: enumOrderStatus.shipped,
            blockReason: '',
            debtRemain: 0,
            isReturn: true,
            productTypeInReturn: 0,
            products: []
        }
    }

    newReturnItem(addSelect: boolean) {
        let ob = {
            uid: uuidv4(),
            countA: '',
            number: 'Продукт номер ',
            code: '',
            price: '',
            date: '',
            name: [],
            datalist: [],
            type: [],
            reason: [],
            selectedType: {label: 'Тип Возврата', value: ''},
            selectedReason: {label: 'Причина Возврата', value: ''},
            selectedName: {label: 'Наименование товара (заполнится автоматически)', value: ''}
        };
        if (addSelect) {
            // @ts-ignore
            ob.reason.push(...this.selectReason);
            // @ts-ignore
            ob.selectedType = this.arProductReturn[0].selectedType;
            // @ts-ignore
            ob.type.push(...this.selectType);
        }
        return ob;
    }

    @action init() {
        ReturnModel.getTypes(this.setTypes, this.setError);
        ReturnModel.getReason(this.setReason, this.setError);
        ReturnModel.getList(this.rootStore?.mainStore.getClientId(), this.setOrderReturn, this.setError);
    }

    @action setTypes = (result: any) => {
        result.data.map((item: any) => {
            this.selectType.push({
                value: item.id,
                label: item.name
            });
            return item;
        });
        this.arProductReturn[0].type = this.selectType;
    }

    @action setReason = (result: any) => {
        result.data.map((item: any) => {
            this.selectReason.push({
                value: item.id,
                label: item.name
            });
            return item;
        });
        this.arProductReturn[0].reason = this.selectReason;
    }

    @action setOrderReturn = (result: any) => {
        this.arOrderReturn = result.data;
    }

    @action
    setError = (error: any) => {
        console.log(error)
    }

    @action setSelectedType = (e: any, item: ReturnItem) => {
        item.selectedType = e;
        this.arProductReturn.map((item: ReturnItem) => {
            item.selectedType = e;
            return item;
        })
    }

    @action setSelectedReason = (e: any, item: ReturnItem) => {
        item.selectedReason = e;
    }

    @action setSelectedName = (e: any, item: ReturnItem) => {
        item.selectedName = e;
    }

    @action setProductCount = (e: any, item: ReturnItem) => {
        item.countA = String(parseInt(e.target.value));
    }

    @action setProductPrice = (e: any, item: ReturnItem) => {
        let price = e.target.value.toString();
        let lastLetter = price.slice(-1);
        if (lastLetter === '.') {
            price = price.slice(0, -1);
        }
        item.price = String(parseFloat(price));
        if (isNaN(Number(item.price))) {
            item.price = String(0);
        }
        if (lastLetter === '.') {
            item.price += '.'
        }
    }


    @action setProductDate = (e: any, item: ReturnItem) => {
        item.date = e.target.value;
    }

    @action setReturnNote = (e: any) => {
        this.return.note = e.target.value;
    }


    @action addProduct = () => {
        this.arProductReturn.push(this.newReturnItem(true));
    }

    @action deleteProduct = (uid: string) => {
        let index = this.arProductReturn.findIndex((item: ReturnItem) => item.uid === uid);
        if (index >= 0) {
            this.arProductReturn.splice(index, 1);
        } else {
            alert('no uid' + uid);
        }
    }


    @action onSubmitForm = (e: any) => {
        e.preventDefault();
        this.setReturnOrder();
        if (!this.return.tradePointId) {
            alert('Выберите торговую точку!');
            return false;
        }
        this.arProductReturn.map((item: ReturnItem) => {

            let vat = 20;
            let price = parseFloat(item.price) ? parseFloat(item.price) : 0;
            let count = parseFloat(item.countA) ? parseFloat(item.countA) : 0;
            let sum = parseFloat((price * count).toFixed(2));
            let Nds = parseFloat((sum * vat / 100).toFixed(2));
            let sumSNDS = parseFloat((sum + Nds).toFixed(2));

            this.return.products.push({
                orderId: 0,
                productId: parseFloat(item.selectedName.value),
                price: price,
                discount: 0,
                sum: sum,
                sumSNDS: sumSNDS,
                count: count,
                countLimit: 0,
                editedOn1C: false,
                reasonReturn: parseFloat(item.selectedReason.value),
                productTypeInReturn: parseFloat(item.selectedType.value),
            });
            return item;
        })
        ReturnModel.addReturn(this.return, this.setOk, this.setError);
        return false;
    }

    setOk = (result: any) => {
        this.setActiveTab(2);
        this.arProductReturn = [];
        this.arProductReturn.push(this.newReturnItem(false));
        ReturnModel.getList(this.rootStore?.mainStore.getClientId(), this.setOrderReturn, this.setError);
    }

    @action
    setProductCode = (e: React.FormEvent<HTMLInputElement>, item: ReturnItem) => {
        const q = e.currentTarget.value;
        let clientId = this.rootStore?.mainStore.getClientId();
        if (q.length > 2) {
            ElementModel.searchCodeLimit(q,5000,  clientId, (result: any) => {
                let data = result.data;
                if (data.length) {
                    item.name = [];
                    item.datalist = [];
                    let i = 0;
                    data.map((el: ISearchCode) => {
                        let option = {value: String(el.blockElementId), label: el.name};
                        if (!i) {
                            item.selectedName = option;
                        }
                        item.name.push(option);
                        item.datalist.push({value: String(el.blockElementId), label: el.barcode});
                        i++;
                        return el;
                    });
                } else {
                    item.selectedName = {label: 'Наименование товара (заполнится автоматически)', value: ''};
                    item.name = [];
                }

            }, this.setError);
        }

    }

    @action setActiveTab = (i: number) => {
        this.getActiveTab = i;
    }

}
